<div class="text-center mb-3 registrador-relogio">
  <div class="clock">{{ agora | date:'HH:mm:ss' }}</div>
  <div class="text-secondary">{{ dataFormatada }}</div>
</div>
